import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('rebuilt_token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await getMe();
      setUser(res.data.user);
      setRole(res.data.role);
    } catch {
      localStorage.removeItem('rebuilt_token');
      localStorage.removeItem('rebuilt_user');
      localStorage.removeItem('rebuilt_role');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = (token, userData, userRole) => {
    localStorage.setItem('rebuilt_token', token);
    localStorage.setItem('rebuilt_user', JSON.stringify(userData));
    localStorage.setItem('rebuilt_role', userRole);
    setUser(userData);
    setRole(userRole);
  };

  const logout = () => {
    localStorage.removeItem('rebuilt_token');
    localStorage.removeItem('rebuilt_user');
    localStorage.removeItem('rebuilt_role');
    setUser(null);
    setRole(null);
  };

  return (
    <AuthContext.Provider value={{ user, role, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
